<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.31641 6.6665H16.181"
      stroke="#0E0E22"
      stroke-miterlimit="10"
    />
    <path
      d="M16.1185 7.49976H17.082C17.6346 7.49976 18.1645 7.71925 18.5552 8.10995C18.9459 8.50065 19.1654 9.03055 19.1654 9.58309C19.1654 10.1356 18.9459 10.6655 18.5552 11.0562C18.1645 11.4469 17.6346 11.6664 17.082 11.6664H15.3945"
      stroke="#0E0E22"
      stroke-miterlimit="10"
    />
    <path
      d="M12.0833 16.2499C14.3854 16.2499 16.25 11.026 16.25 4.58325H1.25C1.25 11.026 3.11458 16.2499 5.41667 16.2499H12.0833Z"
      stroke="#0E0E22"
      stroke-miterlimit="10"
    />
  </svg>
</template>
